  import React, { useEffect, useState } from "react";
  import { Link, useParams } from "react-router-dom";
  import {
    doc,
    getDoc,
    getDocs,
    collection,
    query,
    where,
  } from "firebase/firestore";
  import { db } from "../../firebaseConfig";
  import Navbar from "../../components/navbar/navbar";
  import Footer from "../../components/footer";
  import FooterTop from "../../components/footer-top";
  import { formatAddress, formatAddressForMaps } from '../../utils/addressUtils';

  export default function DetalleProyecto() {
    const { id } = useParams<{ id: string }>();
    const [proyecto, setProyecto] = useState<any>(null);
    const [propiedades, setPropiedades] = useState<any[]>([]);
    const [nombreInmobiliaria, setNombreInmobiliaria] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const fetchProyecto = async () => {
        if (!id) return;

        // Resetear estados
        setLoading(true);
        setProyecto(null);
        setPropiedades([]);
        setNombreInmobiliaria("");

        try {
          const ref = doc(db, "proyectos", id);
          const snap = await getDoc(ref);

          if (snap.exists()) {
            const data = snap.data();
            setProyecto(data);

            // Obtener nombre de inmobiliaria
            if (data.inmobiliaria_id) {
              const q = query(
                collection(db, "inmobiliaria"),
                where("inmobiliaria_id", "==", data.inmobiliaria_id)
              );
              const inmSnap = await getDocs(q);
              if (!inmSnap.empty) {
                setNombreInmobiliaria(inmSnap.docs[0].data().nombre);
              }
            }

            // Obtener propiedades
            if (
              Array.isArray(data.propiedad_id) &&
              data.propiedad_id.length > 0
            ) {
              const q = query(
                collection(db, "propiedades"),
                where("propiedad_id", "in", data.propiedad_id)
              );
              const propSnap = await getDocs(q);
              const propList = propSnap.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
              }));
              setPropiedades(propList);
            }
          }
        } catch (error) {
          console.error("Error al cargar proyecto:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchProyecto();
    }, [id]);

    if (loading) return <p className="text-center mt-5">Cargando proyecto...</p>;
    if (!proyecto)
      return <p className="text-center mt-5">Proyecto no encontrado.</p>;

    return (
      <>
        <Navbar transparent={false} />

        <div className="container my-5">
          <h2 className="mb-3">{proyecto.nombre}</h2>
          <p>
            <strong>Área:</strong> {proyecto.area_m2} m²
          </p>
          <p>
            <strong>Inmobiliaria:</strong> {nombreInmobiliaria}
          </p>
          <p>
            <strong>Dirección:</strong>{" "}
            <a
              href={typeof proyecto.direccion === 'string' ? proyecto.direccion : proyecto.direccion && typeof proyecto.direccion === 'object' ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${proyecto.direccion.calle || ''} ${proyecto.direccion.numero || ''}, ${proyecto.direccion.area || ''}, ${proyecto.direccion.estado || ''}`)}` : '#'}
              target="_blank"
              rel="noopener noreferrer"
            >
              {typeof proyecto.direccion === 'string' ? proyecto.direccion : proyecto.direccion && typeof proyecto.direccion === 'object' ? `${proyecto.direccion.calle || ''} ${proyecto.direccion.numero || ''}, ${proyecto.direccion.area || ''}` : 'Dirección no disponible'}
            </a>
          </p>
          <p>
            <strong>Amenidades:</strong>{" "}
            {proyecto.amenidades?.join(", ") || "N/A"}
          </p>

          <hr className="my-4" />
          <h4>Propiedades Asociadas</h4>

          {propiedades.length > 0 ? (
            <div className="row">
              {propiedades.map((p, i) => (
                <div key={i} className="col-md-6 mb-4">
                  <div className="card p-3 shadow-sm h-100">
                    <h5 className="mb-2">{p.titulo || p.nombre || `Propiedad ${p.list_number || 'Sin título'}`}</h5>
                    <p>
                      <strong>Dirección:</strong> {formatAddress(p.direccion)}
                    </p>
                    <p>
                      <strong>Estado:</strong> {p.estado}
                    </p>
                    <p>
                      <strong>Baños:</strong> {p.baños}
                    </p>
                    <p>
                      <strong>Construcción:</strong> {p.construccion_m2} m²
                    </p>

                    {/* 🔗 Botón para ver detalle de propiedad */}
                    <Link
                      to={`/single-property-1/${p.id}`}
                      className="btn btn-outline-primary btn-sm mt-2"
                    >
                      Ver Detalles de la Propiedad
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p>No hay propiedades asociadas a este proyecto.</p>
          )}
        </div>

        <FooterTop bg="theme-bg" />
        <Footer />
      </>
    );
  }
